import React from 'react';

const About = () => {
  return <div>About Us</div>;
};

export default About;
